import { Identifiable } from "./identifiable";
import { Resource } from "./resource";

type RetrieveWorkLoadsFilter = {
  resources?: Identifiable<Resource>[];
  view: "daily" | "weekly" | "monthly" | "year";
  startDate: string;
  endDate: string;
  chunkKey?: string;
};

const retrieveWorkLoadsFilter: RetrieveWorkLoadsFilter = {
  view: "weekly",
  startDate: "",
  endDate: "",
};

export type { RetrieveWorkLoadsFilter };

export { retrieveWorkLoadsFilter };
